import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import { paddingBuilder } from 'styles/themeUtils';
import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';

import {
  BoxLinkGallery,
  BoxLink,
} from './styles/BoxLink';

function SectionEthicsVideo() {
  return (
    <Section
      minHeight="auto"
      backgroundColor="white.dark"
    >
      <Block
        alignItems="left"
        blockWidth="100%"
        textAlign="Justify"
      >
        <Typography
          color="black"
          variant="paragraph2"
          gutterBottom={1}
          intlKey="ETHICS.DESC.P1"
        />
        <Typography
          color="black"
          variant="paragraph2"
          gutterBottom={1}
          intlKey="ETHICS.DESC.P2"
        />
        <Typography
          color="black"
          variant="paragraph2"
          gutterBottom={1}
          intlKey="ETHICS.DESC.P3"
          intlValues={{ i: (...text) => <i>{text}</i> }}
        />
      </Block>

      <Block
        alignItems="left"
        blockWidth="100%"
        textAlign="Justify"
        padding={{
          default: paddingBuilder.top(0),
          desktop: paddingBuilder.all(0, 4, 4, 4),
        }}
      >
        <BoxLinkGallery>
          <BoxLink>
            <Typography
              variant="subtitle"
              intlKey="ETHICS.ASSETS.WHISTLEBLOWING_CHANNEL"
            />
            <Link
              color="primary"
              variant="action"
              intlKey="ETHICS.KNOW_MORE.TEXT"
              href="http://canalconfidencial.com.br/nubank"
            />
          </BoxLink>

          <BoxLink>
            <Typography
              variant="subtitle"
              intlKey="ETHICS.ASSETS.VIDEO_TITTLE"
            />
            <Link
              href="https://youtu.be/ba5-Y3fvWhc"
              color="primary"
              variant="action"
              intlKey="ETHICS.KNOW_MORE.TEXT"
            />
          </BoxLink>

          <BoxLink>
            <Typography
              variant="subtitle"
              intlKey="ETHICS.ASSETS.PROVIDERS_CODE_OF_CONDUCT"
            />
            <FormattedMessage id="ETHICS.ASSETS.PROVIDERS_CODE_OF_CONDUCT.LINK">
              {([document]) => (
                <Link
                  href={document}
                  color="primary"
                  variant="action"
                  intlKey="ETHICS.KNOW_MORE.TEXT"
                />
              )}
            </FormattedMessage>
          </BoxLink>

          <BoxLink>
            <Typography
              variant="subtitle"
              intlKey="ETHICS.ASSETS.CODE_OF_CONDUCT"
            />
            <FormattedMessage id="ETHICS.ASSETS.CODE_OF_CONDUCT.LINK">
              {([document]) => (
                <Link
                  href={document}
                  color="primary"
                  variant="action"
                  intlKey="ETHICS.KNOW_MORE.TEXT"
                />
              )}
            </FormattedMessage>
          </BoxLink>

          <BoxLink>
            <Typography
              variant="subtitle"
              intlKey="ETHICS.TREATMENT_COMPLAINT_REPUTATIONAL"
            />
            <FormattedMessage id="ETHICS.TREATMENT_COMPLAINT_REPUTATIONAL.LINK">
              {([document]) => (
                <Link
                  href={document}
                  color="primary"
                  variant="action"
                  intlKey="ETHICS.KNOW_MORE.TEXT"
                />
              )}
            </FormattedMessage>
          </BoxLink>

        </BoxLinkGallery>
      </Block>
    </Section>
  );
}

export default React.memo(SectionEthicsVideo);
